<template>
  <!--
      作者 gmshop
      时间：2019-10-26
      q区域树
  -->
  <div class="product-add" >
      <div v-loading="loading">
        <div class="gray9">搜索：Ctrl+F 键 ，输入搜索内容，则可找到相应内容 (1、存在区域代理会自动展开 2、必须展开才能搜索到)</div>
        <div class="gray9">默认展开的则存在区域代理</div>
        <div class="gray9">注意：该结构不会及时更新，缓存时间1个小时</div>
        <div class="common-form">区域代理树展示</div>
        <el-tree
          :data="data"
          show-checkbox
          node-key="id"
          ref="tree"
          highlight-current
          :props="defaultProps"
          :default-expanded-keys="region_ids"
          :default-checked-keys="region_ids"
          >
        </el-tree>
      </div>
  </div>

</template>

<script>
  import RegionAgentApplyApi from '@/api/plus/regionagentapply.js';
  export default {

    data() {
      return {
        /*是否正在加载*/
        loading: true,
        data: [],
        defaultProps: {
          children: 'child',
          label: 'name'
        },
        region_ids:[]
      };
    },
    created() {
      this.getParams()
    },

    methods: {

      /*获取配置数据*/
      getParams() {
        let self = this;
        RegionAgentApplyApi.getTree({}, true).then(res => {
            self.data = res.data.regionTree;
            self.region_ids = res.data.region_ids;
            self.loading=false;
          })
          .catch(error => {
            self.loading=false;
          });
      }
    }
  };
</script>
<style>
  .tips {
    color: #ccc;
  }
</style>



// WEBPACK FOOTER //
// src/views/regionagent/regiontree/index.vue